import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

function MyProfilePage() {
    const history = useHistory();

    useEffect(() => {
        history.replace("/app/mi-cuenta/perfil");
    }, [history]);

    return null;
}

export default MyProfilePage;
